import React from 'react'
import * as d3 from "../d3.modified.js"
import Utils from '../Utils'

export default class ImageNode extends React.PureComponent {
    constructor(props) {
        super(props)
        // this.isJustClickNotDrag = false
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleResize: this.styleResize,
            styleFade: this.styleFade
        }
    }

    findAspectRatio = () => {
        var node = this.props.nodeItem

        this.aspect = undefined
        let img = new Image()
        img.onload = ()=>{
            this.aspect = img.width/img.height
            if (node.width>node.height && this.aspect!==undefined) {
                node.height = node.width/this.aspect
            }
            if (node.width<node.height && this.aspect!==undefined) {
                node.width = node.height*this.aspect
            }
            this.styleResize()
            this.props.resizeHandler(node.width, node.height, node.id)
        }
        img.src = this.props.nodeItem.properties.image
    }

    componentDidMount() {
        var node = this.props.nodeItem

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        this.styleResize()
        this.findAspectRatio()

        const _step = 10

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.position = undefined;
        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()

                // <grided>
                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
                // </grided>

                this.props.dragStartHandler()
            })
            .on('drag', ()=>{
                node.refs.holder.classed('moving', true)
                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                    // <grided>
                    if (this.props.keyPressDict.grid) {
                        let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                        let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                        x = parseInt((x+_step/2)/_step)*_step
                        y = parseInt((y+_step/2)/_step)*_step

                        let dx = x-node.x+node.width*0.5
                        let dy = y-node.y+node.height*0.5
                        this.props.dragHandler(dx, dy)
                    } else {
                    // </grided>
                        this.props.dragHandler(d3.event.dx, d3.event.dy)
                    }
                }
            })
            .on('end', ()=>{
                node.refs.holder.classed('moving', false)
                let newPosition = {x:d3.event.x, y:d3.event.y}
                if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                    this.props.dragEndHandler()
                }
            })
        )

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })

        node.refs.resizer.call(d3.drag()
            .on('start', ()=>{
                node.resizeData = {
                    width: node.width,
                    height: node.height,
                    x: d3.event.x,
                    y: d3.event.y
                }
                this.props.clickHandler(node, false)
            })
            .on('drag', ()=>{
                var newWidth = (d3.event.x-node.resizeData.x) + node.resizeData.width
                if (newWidth>32) {
                    if (this.props.keyPressDict.grid) {
                        node.width = Math.floor(newWidth/_step)*_step
                    } else {
                        node.width = newWidth
                    }
                }
                var newHeight = (d3.event.y-node.resizeData.y) + node.resizeData.height
                if (newHeight>20) {
                    if (this.props.keyPressDict.grid) {
                        node.height = Math.floor(newHeight/_step)*_step
                    } else {
                        node.height = newHeight
                    }
                }

                if (node.width>node.height && this.aspect!==undefined) {
                    node.height = node.width/this.aspect
                }
                if (node.width<node.height && this.aspect!==undefined) {
                    node.width = node.height*this.aspect
                }

                this.styleResize()
                this.props.resizeHandler(node.width, node.height, node.id)
            })
            .on('end', ()=>{
                this.props.resizeEndHandler(node)
            })
        )
    }

    styleResize = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)

        _(node.refs.border, 'width', node.width)
        _(node.refs.border, 'height', node.height)
        _(node.refs.background, 'width', node.width)
        _(node.refs.background, 'height', node.height)

        _(node.refs.resizer, 'x', node.width-10)
        _(node.refs.resizer, 'y', node.height-10)
    }

    componentDidUpdate() {
        var node = this.props.nodeItem
        this.props.enqueueStyleChange({
            elem: node.refs.background,
            prop: 'fill',
            val: node.properties.color
        })
        this.findAspectRatio()
        this.styleResize()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x-node.width/2} ${node.y-node.height/2})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.border,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.border,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        return (
            <g
                className="node-holder node-frame-holder"
                transform={`translate(${node.x-node.width/2} ${node.y-node.height/2})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* FRAME */}
                 <image
                    width={node.width}
                    height={node.height}
                    href={node.properties.image}
                    // preserveAspectRatio="none"
                    ref={c=>node.refs.background=d3.select(c)}
                />
                <rect
                    id={`N_${node.id}_bg`}
                    className="node-frame-border"
                    width={node.width}
                    height={node.height}
                    stroke="#888"
                    strokeWidth="1"
                    fill="transparent"
                    ref={c=>node.refs.border=d3.select(c)}
                />
            {/* RESIZE */}
                <rect
                    x={node.width/2+5}
                    y={node.height/2+5}
                    width="10"
                    height="10"
                    className="node-academic-resizer"
                    ref={c=>node.refs.resizer=d3.select(c)}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/ImageNode.js